import { AlertCircle, RefreshCw } from "lucide-react";

interface AISearchErrorProps {
  onRetry: () => void;
}

export function AISearchError({ onRetry }: AISearchErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-5 py-10">
      <div className="relative" style={{ width: 76, height: 76 }}>
        <div
          className="absolute inset-0 rounded-full border"
          style={{ borderColor: "rgba(239,68,68,0.18)" }}
        />
        <div
          className="absolute rounded-full border"
          style={{ inset: 12, borderColor: "rgba(239,68,68,0.1)" }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(239,68,68,0.14) 0%, transparent 70%)",
              animation: "aiPulseCore 2.4s ease-in-out infinite",
            }}
          />
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <AlertCircle
            className="w-5 h-5"
            style={{ color: "#EF4444", position: "relative", zIndex: 1 }}
          />
        </div>
      </div>

      <div className="text-center px-4">
        <p className="text-sm font-semibold mb-1" style={{ color: "#1A1814" }}>
          Não foi possível buscar os espaços
        </p>
        <p className="text-xs" style={{ color: "#9E9A94" }}>
          Verifique sua conexão e tente novamente
        </p>
      </div>

      <button
        type="button"
        onClick={onRetry}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-semibold transition-opacity hover:opacity-80"
        style={{ background: "#1A1814", color: "#FFD900" }}
      >
        <RefreshCw className="w-3 h-3" />
        Tentar novamente
      </button>
    </div>
  );
}
